"use client"

import { useEffect } from "react"
import { AlertTriangle, RefreshCw } from "lucide-react"

export default function PartnerDashboardError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("[partner-dashboard/error]", error)
  }, [error])

  return (
    <div className="flex min-h-[50vh] items-center justify-center p-6">
      <div className="max-w-md rounded-2xl border border-red-200 bg-red-50 p-6 text-red-900 dark:border-red-900/40 dark:bg-red-950/30 dark:text-red-200">
        <div className="mb-3 flex items-center gap-2">
          <AlertTriangle className="h-5 w-5" aria-hidden />
          <h2 className="font-semibold">Partner dashboard hit an error</h2>
        </div>
        <p className="text-sm text-red-800/80 dark:text-red-200/80">
          Something went wrong rendering this page. The rest of the app is unaffected.
        </p>
        {error?.message ? (
          <p className="mt-3 break-words font-mono text-xs opacity-70">{error.message}</p>
        ) : null}
        <button
          type="button"
          onClick={() => reset()}
          className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-red-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-red-700"
        >
          <RefreshCw className="h-4 w-4" />
          Try again
        </button>
      </div>
    </div>
  )
}
